var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F58634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47449 12.7867H7.47674C8.14555 12.7057 8.70805 12.5032 9.16424 12.1792C9.76836 11.746 10.0704 11.1959 10.0704 10.5288C10.0704 9.9663 9.84936 9.49548 9.4078 9.11017C8.96511 8.72598 8.36549 8.49255 7.60893 8.41155C7.35186 8.37836 6.98736 8.35417 6.51936 8.32717C5.49899 8.2653 4.83693 8.1258 4.5298 7.90698C4.42062 7.82866 4.32872 7.72871 4.2598 7.61336C4.20142 7.50848 4.17119 7.39027 4.17205 7.27023C4.17205 6.95467 4.3543 6.68805 4.72161 6.47823C5.08836 6.26898 5.55186 6.16211 6.11549 6.16211C6.6493 6.16211 7.17861 6.25323 7.67924 6.43211C9.83136 7.19936 11.8867 9.88136 13.2553 11.8017C12.1399 12.4795 10.6206 12.8975 8.94655 12.8975C8.4538 12.8975 7.96161 12.8609 7.47449 12.7867ZM5.06755 11.6943C3.10274 10.9771 2.24268 9.20467 3.21299 7.48342C3.23999 7.7253 3.32943 7.95761 3.47343 8.15842C3.65343 8.41098 3.9178 8.6163 4.26486 8.77773C5.47705 9.30423 7.70624 8.96786 8.62424 9.63667C8.93305 9.86167 9.08774 10.1491 9.08774 10.4995C9.08774 10.94 8.8723 11.3005 8.44143 11.5807C8.01111 11.8608 7.45086 12.0009 6.76124 12.0009C6.18336 11.9976 5.61045 11.8939 5.06811 11.6943H5.06755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.5755 10.6172V7.32434C14.945 7.8244 15.1515 8.38296 15.1515 8.97078C15.1515 9.55915 14.945 10.1166 14.5755 10.6172ZM13.6479 6.42096L13.6507 10.6178C12.3328 8.7469 10.3635 6.39284 7.94304 5.60646C7.52432 5.46973 7.09175 5.37974 6.65323 5.33815C7.40359 5.15324 8.17373 5.06068 8.94654 5.06253C10.8253 5.06253 12.51 5.58903 13.6479 6.42096Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnity);
export default __webpack_public_path__ + "static/media/unity.a255b9f1c9418c9ac41eb0c5134d9010.svg";
export { ForwardRef as ReactComponent };